import { createSlice } from '@reduxjs/toolkit';
import { findSelectPossessionType, searchSelectPossessionType, getSelectPossessionType } from './api';
import { initialState } from './api/interface';

const selectPossessionTypeSlice = createSlice({
  name: 'selectPossessionType',
  initialState,
  reducers: {
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
    },
    setHasMoreToFalse: (state, action) => {
      state.hasMore = action.payload.hasMore;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findSelectPossessionType.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findSelectPossessionType.fulfilled, (state, action) => {
      state.data.push(...action.payload.data);
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
      state.hasMore = action.payload.data.length < 10 ? false : true;
    });
    builder.addCase(findSelectPossessionType.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(searchSelectPossessionType.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(searchSelectPossessionType.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
      state.hasMore = action.payload.data.length < 10 ? false : true;
    });
    builder.addCase(searchSelectPossessionType.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(getSelectPossessionType.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getSelectPossessionType.fulfilled, (state, _) => {
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(getSelectPossessionType.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
  },
});

export const { setSkip, setHasMoreToFalse, setStatus, reset } =
  selectPossessionTypeSlice.actions;
export default selectPossessionTypeSlice.reducer;
